import { type StatsigUser } from "@statsig/react-bindings";
import { parse } from "cookie";

export const STATSIG_CLIENT_INIT_VALUE_COOKIE_NAME = "_sciv";
export const STATSIG_STABLE_ID_COOKIE_NAME = "_ssi";
export const STATSIG_USER_COOKIE_NAME = "_ssui";

export const STATSIG_ACTIVE_EXPERIMENTS = [
  "exp_mobile_confirmation_banner",
  "exp_desktop_offer_page_layout_shift",
  "exp_desktop_confirmation_lottie",
  "exp_price_per_day",
  "exp_price_per_day_mweb",
] as const;

export type StatsigExperimentName = (typeof STATSIG_ACTIVE_EXPERIMENTS)[number];

export interface StatsigExpValueMap {
  exp_mobile_confirmation_banner: {
    bannerType: "normal" | "button" | "none";
  };
  exp_desktop_offer_page_layout_shift: {
    addOnsLocation: "addonsInPopup" | "addonsBelowCta";
  };
  exp_desktop_confirmation_lottie: {
    showLottie: boolean;
  };
  exp_price_per_day: {
    pricePerDay: number;
  };
  exp_price_per_day_mweb: {
    pricePerDay: number;
  };
}

export type StatsigExpValues = {
  [K in StatsigExperimentName]: StatsigExpValueMap[K];
};

export function getClientBootstrapValues() {
  const cookies = parse(document.cookie);
  const clientBootstrapValues = cookies[STATSIG_CLIENT_INIT_VALUE_COOKIE_NAME];
  const encodedUser = cookies[STATSIG_USER_COOKIE_NAME];
  const stableId = cookies[STATSIG_STABLE_ID_COOKIE_NAME];

  let userInfo: StatsigUser = {};
  if (encodedUser) {
    const decodedUser = JSON.parse(atob(decodeURIComponent(encodedUser)));
    userInfo = decodedUser;
  } else if (stableId) {
    userInfo = {
      customIDs: {
        stableID: stableId,
      },
    };
  }

  return { clientBootstrapValues, userInfo };
}
